import SearchBar from "../common/SearchBar";
import { Plus, ListTree } from "lucide-react";
import "../../styles/common.css";
import "../../styles/driverHeader.css"; 

export default function OrderTypeHeader({ total, search, onSearch, onAdd }) {
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <ListTree size={24} className="primaryIcon" />
            <h2>Types de commandes</h2>
          </div>
          <span className="countBadge">{total}</span>
        </div>

        {/* <button className="btnPrimary" onClick={onAdd}>
          Ajouter un type
          <span className="plusIcon">+</span>
        </button> */}
      </div>
   
      <div className="filterActionsRow">
        <div className="searchWrapper" style={{ maxWidth: "100%" }}>
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher un type de commande (ex: Aéroport, Prestige...)"
          />
        </div>
      </div>
    </div>
  );
}